import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faTrash, faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import stopv2 from '../assets/stopv2.png'
import pause from '../assets/pause v2.png'
import stopwatch from '../assets/stopwatch.png'
import play from '../assets/play.png'
import ReactiveWaves from "./visualizerv2";
import api from "api/api";
import ToastMessage from "utils/muialerts/righttoptoast";
import useModalStore from "zustand/zustandstore";
import { convertToddmmyyy } from "utils/date";
import TimeLineStepper from "./tables/timeline";
import Insights from "./tables/insights";
import ImageModal from "./modals/imagemodal";
import VisitSummarymodal from "./modals/visitsummarymodal";
import { Backdrop, CircularProgress } from "@mui/material";
import MRModal from "./modals/mrmodal";



const StaticEditScreen = ({ isPaused,handleencounters,formatTime,audioStreamRef,getimgs,timelinedata,imgdata,isTimeLineLoading,
 rosdata, data,pausemanualRecording,isError,elapsedTime,togglePause,pausedref, setDeleteConfirmationModal,stopTimer,setExitModal,setIsPaused,patientName}) => {
  const [dots, setDots] = useState(".");
   const[myimgurl,setMyimgUrl]=useState('')
    const[isLoading,setIsLoading]=useState(false)
    const [alertmessage, setAlertMessage] = useState('');
    const [severity, setSeverity] = useState('success');
      const [open, setOpen] = useState(false);
      const mydata=useModalStore()
    let sections = [
        { key: "plan", label: "Plan" },
        { key: "assessment", label: "Assessment" },
        {key:'Review Of Systems',label:'Review Of Systems'},
        { key: "chief_complaint", label: "Chief Complaint" },
        { key: "doctor_instructions", label: "Doctor Instructions" },
        { key: "physical_examination", label: "Physical Examination" },
        { key: "history_of_present_illness", label: "History Of Present Illness" },
      ];
      if(mydata.usertype==='BUSINESS'){
        sections=[
          { key: "Date", label: "Date" },
          { key: "Action Items", label: "Action Items" },
          {key:'Decisions Made',label:'Decisions Made'},
          { key: "Additional Notes", label: "Additional Notes" },
          { key: "Topics Discussed", label: "Topics Discussed" },
       
        ]
      }
    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpen(false);
    }; 
    const percentage = 100;
    const circleStyle = {
      background: `conic-gradient(#50869A ${percentage * 3.6}deg, #EDEDED ${percentage * 3.6}deg)`,
    };

  const handlealertClick = (message, severity) => {
    setAlertMessage(message);
    setSeverity(severity);
    setOpen(true);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev === "." ? ".." : prev === ".." ? "..." : "."));
    }, 500);
    return () => clearInterval(interval);
  }, []);
 function checkImage(url) {
  const img = new Image();
  img.onload = function() {
     
      setMyimgUrl(true)
  };
  img.onerror = function() {
      console.log("Failed to load image");
      setMyimgUrl(false)
  };
  img.src = url;
}
useEffect(()=>{
  if (typeof data === 'object' && data !== null&&mydata.usertype==='PRO') {
checkImage(`https://api.prd.brainymed.com/bs/patient-profile-pictures/${data?.config?.practiceid}/${mydata.selectedRecord?.patientid}.png`)
  }

},[mydata,data])




  return (<>
   <div className="w-full">
   {mydata.usertype==='PRO'?
   <div className='flex w-full gap-4 mt-6  items-center p-4'>    
      
     <div>
       <div
className="relative flex justify-center items-center w-[83px] h-[83px] rounded-full ml-4"
style={circleStyle}
>
<div className="flex justify-center items-center w-[70px] h-[70px] bg-[#FAFAF9] rounded-full">
<img
      src={myimgurl&&data?`https://api.prd.brainymed.com/bs/patient-profile-pictures/${data?.config?.practiceid}/${mydata.selectedRecord?.patientid}.png`:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg=='}
      alt="profile"
      className="flex justify-center items-center w-[60px] h-[60px] bg-[#C4C4C4] rounded-full"
    />
</div>
</div>  
     </div>
 
 <div className="text-start font-sans  font-normal">
{mydata.selectedRecord.patient_name || mydata.selectedRecord.patientid ? (<>
 <div className="text-xxl flex items-center gap-4 sm:text-2xl text-gray-600">
   {mydata.selectedRecord.patient_name} {mydata.usertype==='PRO'? <div className="rounded-lg sm:rounded-full px-2 py-1 text-xs font-medium bg-[#DBEAFE] text-[#0E0E0E]">
  {mydata.selectedRecord?.purpose}
   </div>:<></>}
 </div>
 <div className="text-xxl text-gray-600">
 {mydata.selectedRecord.patientid ? `${mydata.selectedRecord.patientid}` : ''}

 </div>
 {mydata.usertype==='PRO'?<>     <div className="text-xxl text-gray-600">{convertToddmmyyy(mydata.selectedRecord?.dob)||''}</div></>:<></>}
</>) : null}
</div>

       </div>:<></>}
    <div className={`w-full ${mydata.usertype=='PRO'?'':'min-h-screen mt-8'} p-8 flex flex-col justify-center`}>
      
    <div className="flex w-full">  
     
        <div className="w-full mr-8 flex gap-4 items-center justify-end">
          <div className="flex gap-4 items-center">
        
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="22" viewBox="0 0 19 22" fill="none">
  <path d="M7.97192 2.5C7.68859 2.5 7.45126 2.404 7.25992 2.212C7.06859 2.02 6.97259 1.78267 6.97192 1.5C6.97126 1.21733 7.06726 0.98 7.25992 0.788C7.45259 0.596 7.68992 0.5 7.97192 0.5H11.9719C12.2553 0.5 12.4929 0.596 12.6849 0.788C12.8769 0.98 12.9726 1.21733 12.9719 1.5C12.9713 1.78267 12.8753 2.02033 12.6839 2.213C12.4926 2.40567 12.2553 2.50133 11.9719 2.5H7.97192ZM9.97192 13.5C10.2553 13.5 10.4929 13.404 10.6849 13.212C10.8769 13.02 10.9726 12.7827 10.9719 12.5V8.5C10.9719 8.21667 10.8759 7.97933 10.6839 7.788C10.4919 7.59667 10.2546 7.50067 9.97192 7.5C9.68926 7.49933 9.45192 7.59533 9.25992 7.788C9.06792 7.98067 8.97192 8.218 8.97192 8.5V12.5C8.97192 12.7833 9.06792 13.021 9.25992 13.213C9.45192 13.405 9.68926 13.5007 9.97192 13.5ZM9.97192 21.5C8.73859 21.5 7.57592 21.2627 6.48392 20.788C5.39192 20.3133 4.43792 19.6673 3.62192 18.85C2.80592 18.0327 2.16026 17.0783 1.68492 15.987C1.20959 14.8957 0.971924 13.7333 0.971924 12.5C0.971924 11.2667 1.20959 10.104 1.68492 9.012C2.16026 7.92 2.80592 6.966 3.62192 6.15C4.43792 5.334 5.39226 4.68833 6.48492 4.213C7.57759 3.73767 8.73992 3.5 9.97192 3.5C11.0053 3.5 11.9969 3.66667 12.9469 4C13.8969 4.33333 14.7886 4.81667 15.6219 5.45L16.3219 4.75C16.5053 4.56667 16.7386 4.475 17.0219 4.475C17.3053 4.475 17.5386 4.56667 17.7219 4.75C17.9053 4.93333 17.9969 5.16667 17.9969 5.45C17.9969 5.73333 17.9053 5.96667 17.7219 6.15L17.0219 6.85C17.6553 7.68333 18.1386 8.575 18.4719 9.525C18.8053 10.475 18.9719 11.4667 18.9719 12.5C18.9719 13.7333 18.7343 14.896 18.2589 15.988C17.7836 17.08 17.1379 18.034 16.3219 18.85C15.5059 19.666 14.5516 20.312 13.4589 20.788C12.3663 21.264 11.2039 21.5013 9.97192 21.5Z" fill="#2C5282"/>
</svg>
             
<div className="text-[#2C5282]">        {formatTime(elapsedTime)}s </div>

 <ReactiveWaves isPaused={!isPaused}  mediaStream={audioStreamRef.current}/>

          </div>

{!isPaused?<><div className="cursor-pointer" onClick={() => {
                togglePause()

               }}>

               <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M0.166748 3.25C0.166748 1.75691 0.166748 1.01116 0.630665 0.547245C1.09458 0.0833282 1.84033 0.0833282 3.33342 0.0833282C4.8265 0.0833282 5.57225 0.0833282 6.03616 0.547245C6.50008 1.01116 6.50008 1.75691 6.50008 3.25V12.75C6.50008 14.2431 6.50008 14.9888 6.03616 15.4527C5.57225 15.9167 4.8265 15.9167 3.33342 15.9167C1.84033 15.9167 1.09458 15.9167 0.630665 15.4527C0.166748 14.9888 0.166748 14.2431 0.166748 12.75V3.25ZM9.66675 3.25C9.66675 1.75691 9.66675 1.01116 10.1307 0.547245C10.5946 0.0833282 11.3403 0.0833282 12.8334 0.0833282C14.3265 0.0833282 15.0722 0.0833282 15.5362 0.547245C16.0001 1.01116 16.0001 1.75691 16.0001 3.25V12.75C16.0001 14.2431 16.0001 14.9888 15.5362 15.4527C15.0722 15.9167 14.3265 15.9167 12.8334 15.9167C11.3403 15.9167 10.5946 15.9167 10.1307 15.4527C9.66675 14.9888 9.66675 14.2431 9.66675 12.75V3.25Z" fill="#2C5282"/>
</svg>
  </div></>:
<div className="cursor-pointer border-2 border-[#e5e5e56e] px-2 bg-[#FFF]"   onClick={() => {
                togglePause()
               }}>
  <FontAwesomeIcon icon={faPlay} />
</div>}
<div      onClick={()=> {
      if(!isPaused){
       stopTimer()
       pausedref.current=false
       setIsPaused(true)
       if(isError){
        pausemanualRecording()
       }
       
      }
      setExitModal(true)

             //   pauseRecording();
                                           
               }} className="border-2  cursor-pointer border-[#e5e5e56e] px-2 py-[5px] bg-[#FFF]">
<svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
               <path d="M0 13V3C0 2.3125 0.245 1.72417 0.735 1.235C1.225 0.745833 1.81333 0.500833 2.5 0.5H12.5C13.1875 0.5 13.7762 0.745 14.2662 1.235C14.7562 1.725 15.0008 2.31333 15 3V13C15 13.6875 14.7554 14.2762 14.2662 14.7662C13.7771 15.2562 13.1883 15.5008 12.5 15.5H2.5C1.8125 15.5 1.22417 15.2554 0.735 14.7662C0.245833 14.2771 0.000833333 13.6883 0 13Z" fill="#2C5282"/>
             </svg>
</div>

<div className="text-red-500 cursor-pointer"
onClick={() => {
    if(!pausedref.current){
      stopTimer()
      setIsPaused(true)
      pausedref.current=false              
     
     }
 setDeleteConfirmationModal(true)
  }}
>
<FontAwesomeIcon icon={faTrash}  />

</div>

        </div>


    </div>
    <div className={`flex gap-8 ${mydata.usertype !== 'PRO' ? 'w-full' : 'w-full '}`}>
      <div className="w-full mt-4 grid grid-cols-1 sm:grid-cols-3 gap-4">
      {sections.map((section, idx) => {
        let customClasses = "";
        if (idx % 6 === 0 || idx % 6 === 1 || idx % 6 === 2) {
          customClasses = "col-span-3 sm:col-span-1 min-h-[120px]";
        } else if (idx % 6 === 3) {
          customClasses = "col-span-3 min-h-[120px]";
        } else if (idx % 6 === 4) {
          customClasses = "col-span-3 sm:col-span-1 min-h-[120px]";
        } else {
          customClasses = "col-span-3 sm:col-span-2 min-h-[120px]";
        }

        return (
<div
  key={section.key}
  className={`flex flex-col justify-start items-start w-auto max-w-full ${customClasses}`}
  style={{
    borderRadius: "8px",
    border: "1px solid rgba(162, 198, 253, 0.40)",
    background: "#FFF",
    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
    flex: "1 0 auto",
  }}
>
  <div className="flex items-center justify-between w-full h-10 px-4 bg-blue-100 rounded-md">
    <h1 className="text-sm font-bold text-[#262629]">
      {section.label}
    </h1>
    <div className="flex items-center gap-4">
      {section.label === "Doctor Instructions" && (
        <ShareOutlinedIcon
          sx={{ fontSize: "18px", color: "#676767", cursor: "pointer" }}
        />
      )}
      <FontAwesomeIcon
        icon={faUpRightFromSquare}
        className="text-[#7E7E7E] cursor-pointer"
      />
    </div>
  </div>
  
  <div className="w-full flex justify-start p-4 text-[#374151]">
    <div 
      className="text-lg text-start w-full max-h-40 overflow-y-auto" 
      style={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}
    >
      {section.key === "Review Of Systems" && rosdata && mydata.usertype === "PRO" ? rosdata : dots}
    </div>
  </div>
</div>

        );
      })}
    </div>
    {mydata.usertype=='PRO'?<div className='mt-[4%] hidden sm:flex flex-col gap-4'>
    
    <TimeLineStepper handleencounters={handleencounters}  getimgs={getimgs} data={timelinedata} imgdata={imgdata} isTimeLineLoading={isTimeLineLoading}/>
    <Insights/>
     
    </div>:<></>}
    </div>
    </div>
    </div>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
         <CircularProgress color="inherit" />
       </Backdrop>
   
  </>
  );
};

export default StaticEditScreen;
